/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which bases are supported?`)
};

const es_nb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué bases se admiten?`)
};

const de_nb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Basen werden unterstützt?`)
};

const nl_nb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke bases worden ondersteund?`)
};

const fr_nb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles sont les bases prises en charge ?`)
};

const it_nb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali basi sono supportate?`)
};

const pt_br2_nb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais bases são suportadas?`)
};

const pt_nb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais são as bases suportadas?`)
};

const ja_nb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのベースがサポートされていますか？`)
};

const zh_nb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持哪些进制？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_faq1_q", locale)
	if (locale === "en") return en_nb_faq1_q(inputs)
	if (locale === "es") return es_nb_faq1_q(inputs)
	if (locale === "de") return de_nb_faq1_q(inputs)
	if (locale === "nl") return nl_nb_faq1_q(inputs)
	if (locale === "fr") return fr_nb_faq1_q(inputs)
	if (locale === "it") return it_nb_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_nb_faq1_q(inputs)
	if (locale === "pt") return pt_nb_faq1_q(inputs)
	if (locale === "ja") return ja_nb_faq1_q(inputs)
	return zh_nb_faq1_q(inputs)
};